export default __webpack_public_path__ + "static/media/prev-profile-oval.cf93f4f1.svg";